import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { UnumCoverageOptionDto } from 'enrollment/queries/useUnumGetPlansQuery/types';
import { CoverageNumbersStyled } from './UnumStyled';
import { getPremiumStyled } from 'enrollment/utils';

interface IncrementAmountProps {
  show: boolean;
  description: string;
  parentIndex: number;
  onAmountChange: (increment?: UnumCoverageOptionDto, planId?: number) => void;
  increments: UnumCoverageOptionDto[];
}
export const IncrementAmounts = ({
  increments,
  show,
  description,
  parentIndex,
  onAmountChange,
}: IncrementAmountProps) => {
  const numbersRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation('pages.volume');
  const isMobile = window.innerWidth < 744;

  const firstEOIRequired = increments.findIndex((option) => {
    return option.GI === 'false';
  });
  const lastNonEoiIncrement =
    firstEOIRequired === 0 ? -1 : firstEOIRequired - 1;
  const noEOI = firstEOIRequired === -1;

  useEffect(() => {
    // Whenever the `show` prop changes to true, focus the `div`.
    if (show && numbersRef.current) {
      numbersRef.current.focus();
    }
  }, [show]);

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const spans = event.currentTarget.getElementsByTagName('span');
    const covOptionId = spans[0].id || '';

    const increment = increments.find(
      (increment) => increment.CoverageOptionID === covOptionId
    );

    onAmountChange(increment, parentIndex);
  };

  const renderButtons = (requireEoi: string) => {
    return increments
      .filter((inc) => inc.GI === requireEoi)
      .map((inc, index) => (
        <button key={index} onClick={handleButtonClick} type="button">
          <span id={inc.CoverageOptionID}>
            {!isMobile ? `${description} -` : ''}{' '}
            {Number(inc.BenefitCoverage) >= 0
              ? `${getPremiumStyled({
                  premium: inc.BenefitCoverage,
                  valueOnly: true,
                })} -`
              : inc.Description}{' '}
            (
            {getPremiumStyled({ premium: inc.BenefitPremium, valueOnly: true })}
            )
          </span>
        </button>
      ));
  };

  return (
    <CoverageNumbersStyled
      className={`collapse${show ? ' show' : ''}`}
      ref={numbersRef}
      // Make div focusable by adding tabindex - WCAG
      tabIndex={-1}
    >
      <div id="guaranteed" className="faux-select">
        {(noEOI || lastNonEoiIncrement !== -1) && (
          <div className="title">{t('guaranteed')}</div>
        )}
        {renderButtons('true')}
      </div>
      {!noEOI && (
        <div id="approval" className="faux-select">
          <div className="title">{t('requires')}</div>
          {renderButtons('false')}
        </div>
      )}
    </CoverageNumbersStyled>
  );
};
